<template>
  <ac-toast
    v-if="currentToast"
    :key="currentToast.id"
    :class="currentToast.customClass"
    :title="currentToast.title"
    :text="currentToast.text"
    :type="currentToast.type"
    :location="currentToast.location"
    :text-position="currentToast.textPosition"
    :timeout="currentToast.timeout ?? 0"
    :can-close="currentToast.canClose ?? true"
    :icon="!currentToast.iconHtml && !currentToast.iconVariant ? currentToast.icon : undefined"
    @close="onClose"
  >
    <template v-if="currentToast.iconHtml" #icon>
      <div class="toast-container_icon" v-html="currentToast.iconHtml" />
    </template>
    <template v-else-if="currentToast.iconVariant === 'success'" #icon>
      <div class="toast-container_icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22H2.9937C2.11018 22 1.66771 20.9229 2.29245 20.2929L4.2495 18.3195C2.84334 16.597 2 14.397 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.7071 10.7071C16.0976 10.3166 16.0976 9.68342 15.7071 9.29289C15.3166 8.90237 14.6834 8.90237 14.2929 9.29289L11 12.5858L9.70711 11.2929C9.31658 10.9024 8.68342 10.9024 8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L10.2929 14.7071C10.4804 14.8946 10.7348 15 11 15C11.2652 15 11.5196 14.8946 11.7071 14.7071L15.7071 10.7071Z" fill="white"/>
        </svg>
      </div>
    </template>
    <template v-else-if="currentToast.iconVariant === 'error'" #icon>
      <div class="toast-container_icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.0007 10.5867L16.2437 6.34372C16.6342 5.95325 17.2673 5.95325 17.6577 6.34372V6.34372C18.0482 6.73418 18.0482 7.36725 17.6577 7.75772L13.4147 12.0007L17.6577 16.2437C18.0482 16.6342 18.0482 17.2673 17.6577 17.6577V17.6577C17.2673 18.0482 16.6342 18.0482 16.2437 17.6577L12.0007 13.4147L7.75772 17.6577C7.36725 18.0482 6.73418 18.0482 6.34372 17.6577V17.6577C5.95325 17.2673 5.95325 16.6342 6.34372 16.2437L10.5867 12.0007L6.34372 7.75772C5.95325 7.36725 5.95325 6.73418 6.34372 6.34372V6.34372C6.73418 5.95325 7.36725 5.95325 7.75772 6.34372L12.0007 10.5867Z" fill="currentColor"/>
        </svg>
      </div>
    </template>
  </ac-toast>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import AcToast from '@web/ui-kit/components/AcToast.vue'
import { useStore } from '@web/store'

export default defineComponent({
  name: 'ToastContainer',
  components: { AcToast },
  setup () {
    const store = useStore()
    const currentToast = computed(() => store.getters['toast/currentToast'])

    function onClose () {
      store.dispatch('toast/close')
    }

    return {
      currentToast,
      onClose
    }
  }
})
</script>

<style lang="scss" scoped>
.toast-container_icon {
  width: 24px;
  height: 24px;
}
</style>

<style lang="scss">
/* Глобальные стили для кастомных классов тоста (не scoped, чтобы можно было применять снаружи) */
.toast-one-click-success {
  max-width: 536px !important;
  width: 100% !important;
  left: 50% !important;
  bottom: 28px !important;
  right: unset !important;
  transform: translate(-50%, 0) !important;

  @media (max-width: 768px) {
    max-width: calc(100% - 20px) !important;
    top: 65px !important;
    bottom: unset !important;
  }

  &-icon {
    width: 24px;
    height: 24px;
  }
}
/* Глобальные стили для кастомных классов тоста (не scoped, чтобы можно было применять снаружи) */
.toast-offboarding {
  max-width: calc(100% - 20px) !important;
  white-space: nowrap;
  width: auto !important;
  left: 50% !important;
  bottom: 28px !important;
  right: unset !important;
  transform: translate(-50%, 0) !important;

  @media (max-width: 768px) {
    width: 100% !important;
    top: 65px !important;
    bottom: unset !important;
    white-space: normal;
  }

  &-icon {
    width: 24px;
    height: 24px;
  }
}
</style>
